import React, { Component } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, Cell, Grid } from 'react-md';
import { browserHistory, Redirect } from 'react-router';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import quizStyles from '../css/quizStyles.css.js';
import styles from '../css/styles.css.js';
import { AppProperties } from '../common/function';
import { SegmentedControl } from 'segmented-control';
import SectionStudentEnrollmentList from "./SectionStudentEnrollmentList.js";
import { NotificationManager } from 'react-notifications';

export default class QuizList extends Component {
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  constructor(props) {
    super(props);
    this.state = {
      quizList: [],
      temp_id: '',
      visible: false,
      addMode: true,
      loading: false,
      course_id: this.props.location.query.course_id,
      course_name: this.props.location.query.course_name,
      is_lti_enabled: this.props.location.query.is_lti_enabled,
      section_name: this.props.location.query.section_name,
      section_id: this.props.location.query.section_id,
      subsection_name: this.props.location.query.subsection_name,
      subsection_id: this.props.location.query.subsection_id,
      semester_id: this.props.location.query.semester_id,
      semester_name: this.props.location.query.semester_name,
      is_current_semester: (this.props.location.query.is_current_semester === "true"),
      timezone: "America/New_York",
      showQuizzes: true,
      showStudents: false,
    };
    this.deleteQuiz = this.deleteQuiz.bind(this);
    this.newQuizCreation = this.newQuizCreation.bind(this);
    this.editSubject = this.editSubject.bind(this);
  }

  componentWillMount() {
    this.setState({ loading: true });

    const payload = {
      course_id: parseInt(this.props.location.query.course_id, 10),
      section_id: parseInt(this.props.location.query.section_id, 10),
      subsection_id: this.props.subSection ? parseInt(this.state.subsection_id,10) : 0,
      semesterID: parseInt(this.state.semester_id, 10),
      archiveMode: this.state.is_current_semester ? false : true
    };
    console.debug('payload: ', payload);
    ApiRequestService({
      method: 'post',
      url: '/getAllQuiz',
      data: payload
    }).then(res => {
      console.debug('Quizes', res.data.data);
      if (res.data.data != null && res.data.data.quizes_list != null) {
        this.setState({
          quizList: res.data.data.quizes_list,
          timezone: res.data.data.time_zone,
        });
      }
    });

    this.setState({
      loading: false
    });
  }
  componentWillUnmount() {
    this.removeBreadCrumbs();
  }

  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
  };

  handleUpdateAssignmentStatus = (assignment, id) => {
    const payload = {
      quiz_id: assignment.quiz_id,
      status: assignment.status === 0 ? 1 : 0
    };
    console.debug("payload>>>>>", payload)

    const response = ApiRequestService({
      method: 'POST',
      url: '/updateAssignmentStatus',
      data: payload
    })

    response.then(res => {
      console.debug("res", res)
      if (res.data.message !== null && res.data.message !== '') {
        NotificationManager.error(res.data.message, 'ERROR', 3000);
      }else{
        if (res.data.data != null) {
          let tempQuizList = this.state.quizList;
          tempQuizList[id].status = payload.status;
          if (payload.status) {
            NotificationManager.success("Successfully Published", "", 2000);
          } else {
            NotificationManager.success("Successfully Unpublished", "", 2000);
          }
          console.debug(" tempQuizList[id]",  tempQuizList[id])
          this.setState({
            quizList: tempQuizList
          });
        }
      }
    })

  }

  addBreadCrumbs = () => {
    console.debug('Sections AddBreadCrumbs');
    this.props.replaceBreadCrumb([
      {
        name:(this.appProperties.schoolMode?'All Standards':'All Courses'),
        type: '',
        onclickPath: 'Courses'
      },
      {
        name: this.state.course_name,
        type: 'Courses',
        onclickPath:
          'sections?course_id=' +
          this.state.course_id +
          '&course_name=' +
          this.state.course_name +
          '&is_lti_enabled=' +
          this.props.location.query.is_lti_enabled +
          '&semester_id=' +
          this.state.semester_id +
          '&semester_name=' +
          this.state.semester_name +
          '&is_current_semester=' +
          this.state.is_current_semester
      },
     ( this.props.subSection !== true && this.props.sectionTabs !== true) &&
      {
        name: this.state.section_name,
        type: 'Section',
        onclickPath:
          'quizList?section_id=' +
          this.state.section_id +
          '&course_id=' +
          this.state.course_id +
          '&course_name=' +
          this.state.course_name +
          '&section_name=' +
          this.state.section_name +
          '&is_lti_enabled=' +
          this.props.location.query.is_lti_enabled +
          '&semester_id=' +
          this.state.semester_id +
          '&semester_name=' +
          this.state.semester_name +
          '&is_current_semester=' +
          this.state.is_current_semester
      },
      (this.props.subSection === true || this.props.sectionTabs === true) && 
      {
        name: this.state.section_name,
        type: 'Section',
        onclickPath:
          'sectionTabs?section_id=' +
          this.state.section_id +
          '&course_id=' +
          this.state.course_id +
          '&course_name=' +
          this.state.course_name +
          '&section_name=' +
          this.state.section_name +
          '&is_lti_enabled=' +
          this.props.location.query.is_lti_enabled +
          '&semester_id=' +
          this.state.semester_id +
          '&semester_name=' +
          this.state.semester_name +
          '&is_current_semester=' +
          this.state.is_current_semester
      },
      (this.props.subSection === true && this.props.sectionTabs !== true )? 
      {
        name: this.state.subsection_name,
        type: 'Subsetions',
        onclickPath: 
           'subSectionTabs?subsection_id=' +
           this.state.subsection_id +
           '&subsection_name=' +
           this.state.subsection_name +
           '&section_id=' +
           this.state.section_id +
           '&section_name=' +
           this.state.section_name +
           '&course_id=' +
           this.state.course_id +
           '&course_name=' +
           this.state.course_name +
           '&is_lti_enabled=' +
            this.props.location.query.is_lti_enabled +
            '&semester_id=' +
            this.state.semester_id +
            '&semester_name=' +
            this.state.semester_name +
            '&is_current_semester=' +
            this.state.is_current_semester
      } : ''
    ]);
  };
  newQuizCreation(e) {

    const link = this.baseFolder +
    (this.props.subSection !== undefined ?
      'QuizCreation?section_id=' +
      this.props.location.query.section_id +
      '&course_id=' +
      this.props.location.query.course_id +
      '&course_name=' +
      this.props.location.query.course_name +
      '&is_lti_enabled=' +
      this.props.location.query.is_lti_enabled +
      '&section_name=' +
      this.props.location.query.section_name +
      '&subsection=' +
       this.props.subSection +
      '&subsection_id=' +
      this.state.subsection_id +
      '&subsection_name=' +
      this.state.subsection_name  +
      '&semester_id=' +
      this.state.semester_id +
      '&semester_name=' +
      this.state.semester_name +
      '&is_current_semester=' +
      this.state.is_current_semester
      :
      'QuizCreation?section_id=' +
      this.props.location.query.section_id +
      '&course_id=' +
      this.props.location.query.course_id +
      '&course_name=' +
      this.props.location.query.course_name +
      '&is_lti_enabled=' +
      this.props.location.query.is_lti_enabled +
      '&section_name=' +
      this.props.location.query.section_name) +
      '&semester_id=' +
      this.state.semester_id +
      '&semester_name=' +
      this.state.semester_name +
      '&is_current_semester=' +
      this.state.is_current_semester

      console.debug("link", link);

      this.props.router.push(link)
     
  }

  componentDidUpdate() {
    this.addBreadCrumbs();
  }
  delete = id => {
    const confirmMsg = "WARNING: You are about to erase a assignment. This will remove" +
     "all student data associated with this assignment. You might want to consider taking a " +
     "backup by downloading as CSV or excel.\n Do you wish to proceed?";
    if(window.confirm(confirmMsg) === true){
       this.deleteQuiz(id)
    };
  };

  deleteQuiz(id) {
    this.setState({ loading: true });
    console.debug('Delete quiz by id', id);
    console.debug('Delete quiz list', this.state.quizList);
    console.debug('Delete quiz by id', this.state.quizList[id].quiz_id);

    const payload = {
      quiz_id: parseInt(this.state.quizList[id].quiz_id, 10),
      course_id: parseInt(this.props.location.query.course_id, 10),
      section_id: parseInt(this.props.location.query.section_id, 10),
      subsection_id: this.props.subSection? parseInt(this.props.location.query.subsection_id, 10) : 0
    };
    console.debug('Delete payload', payload);
    ApiRequestService({
      method: 'post',
      url: '/deleteQuiz',
      //url: 'http://localhost:8095/deleteQuiz',
      data: payload
    }).then(res => {
      console.debug(res);
      this.state.quizList.splice(id, 1);
      this.setState({
        quizList: this.state.quizList
      });
    });
    this.setState({
      loading: false
    });
  }
  editSubject(id) {
    console.debug("id>>??", id)
    browserHistory.push(
      this.baseFolder +
      this.props.subSection ?
        'QuizCreation?course_id=' +
        this.state.course_id +
        '&section_id=' +
        this.state.section_id +
        '&quiz_id=' +
        id +
        '&course_name=' +
        this.props.location.query.course_name +
        '&section_name=' +
        this.props.location.query.section_name +
        '&subsection=' +
         this.props.subSection +
        '&subsection_id=' +
        this.state.subsection_id +
        '&subsection_name=' +
        this.state.subsection_name +
        '&is_lti_enabled=' +
        this.props.location.query.is_lti_enabled +
        '&semester_id=' +
        this.state.semester_id +
        '&semester_name=' +
        this.state.semester_name +
        '&is_current_semester=' +
        this.state.is_current_semester
         : 
        'QuizCreation?course_id=' +
        this.state.course_id +
        '&section_id=' +
        this.state.section_id +
        '&quiz_id=' +
        id +
        '&course_name=' +
        this.props.location.query.course_name +
        '&section_name=' +
        this.props.location.query.section_name +
        '&is_lti_enabled=' +
        this.props.location.query.is_lti_enabled +
        '&semester_id=' +
        this.state.semester_id +
        '&semester_name=' +
        this.state.semester_name +
        '&is_current_semester=' +
        this.state.is_current_semester
    );
  }

  tabOnChange =(clickedValue) => {
    console.log('clicked value', clickedValue)
    
    if(clickedValue === 'Quizzes'){
        this.setState({showQuizzes:true,showStudents: false});
    }
    if(clickedValue === 'Students'){
        this.setState({showQuizzes:false,showStudents: true});
    }
}
  

  render() {
    let button = null;
    if (this.state.addMode) {
      button = (
        <button style={styles.addButton} onClick={this.addSubject}>
          Add Subject
        </button>
      );
    } else {
      button = (
        <button style={styles.addButton} onClick={this.updateSubject}>
          Update Subject
        </button>
      );
    }
    var cancelButton = (
      <button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

    return (
      (this.state.loading)?
         <LoadingSpinner loading={this.state.loading} />
      :
      <SecureShow targetRole={1}>
        <Grid style={{ width: '100%' }}>

        <SegmentedControl 
              name="section_tabs"
              style={{color: '#bb0000', display: this.props.subSection ? 'none' : 'block'}}
              options ={[
                  { label: 'Assignments', value:'Quizzes',default: true  },
                  { label: 'Students', value:'Students', }
              ]}
              setValue={value => this.tabOnChange(value)}
          />

           {
                this.state.showQuizzes?
                <Cell size={12} className="gradebook-cell">   
                

          {/* <div style={{ marginLeft: '18px' }}>
            <Button
              flat
              secondary
              swapTheming
              style={{
                backgroundColor: '#960000',
                marginTop: '15px',
                marginLeft: '10px',
                fontSize: '16px',
                color: '#ffffff',
                width: '300px',
                height: '40px',
                border: 'none'
              }}
              onClick={this.newQuizCreation}
            >
              New Assignment
            </Button>
          </div> */}

          {/* <div style={quizStyles.quizTitle}>
            <h3>Assignment List</h3>
            <p>{this.appProperties.schoolMode?"Current Academic Year":"Current semester"}</p>
          </div> */}

          <div style={{
              fontSize: '20px',
              padding: '10px',
              background: '#fff',
              color: '#576271',
              marginLeft: '30px',
              display:"flex",
              justifyContent:'space-between',
              alignItems:"center",
              marginTop:'2rem !important',
          }}>
            {this.state.semester_name} | Assignment List
            {this.state.is_current_semester ? 
            <div>
            <Button
              primary
              raised
              onClick={this.newQuizCreation}
            >
              New Assignment
            </Button>
            </div>
            : null}
          </div>

          <table style={{
            ...quizStyles.quizTable,
            marginTop:'20px !important'
          }}>
            <thead style={styles.thead}>
              <tr>
                <th>ID</th>
                <th>Assignment Name</th>
                <th>Start Date</th>
                <th>Due Date</th>
                {this.props.location.query.is_lti_enabled === "true" ? 
                  null
                : <th>Publish/Unpublish</th>}
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {this.state.quizList.map((quizList, i) => (
                <TableRow
                  key={i}
                  data={quizList}
                  id={quizList.quiz_id}
                  name={quizList.quiz_name}
                  title={'Assignments'}
                  type={'Quizes'}
                  index={i}
                  status={quizList.status}
                  isLtiCourse={this.props.location.query.is_lti_enabled === "true"}
                  url={
                    this.props.sectionTabs?
                    'QuizCreation?course_id=' +
                    this.state.course_id +
                    '&section_id=' +
                    this.state.section_id +
                    '&quiz_id=' +
                    quizList.quiz_id +
                    '&subsection_id=' +
                    this.props.location.query.subsection_id +
                    '&course_name=' +
                    this.props.location.query.course_name +
                    '&section_name=' +
                    this.props.location.query.section_name +
                    '&subsection=' +
                    this.props.subSection +
                    '&subsection_name=' +
                    this.props.location.query.subsection_name +
                    '&sectionTabs=' +
                    this.props.sectionTabs +
                    '&is_lti_enabled=' +
                    this.props.location.query.is_lti_enabled +
                    '&semester_id=' +
                    this.state.semester_id +
                    '&semester_name=' +
                    this.state.semester_name +
                    '&is_current_semester=' +
                    this.state.is_current_semester
                    :
                    this.props.subSection ? 
                    'QuizCreation?course_id=' +
                    this.state.course_id +
                    '&section_id=' +
                    this.state.section_id +
                    '&quiz_id=' +
                    quizList.quiz_id +
                    '&subsection_id=' +
                    this.props.location.query.subsection_id +
                    '&course_name=' +
                    this.props.location.query.course_name +
                    '&section_name=' +
                    this.props.location.query.section_name +
                    '&subsection=' +
                    this.props.subSection +
                    '&subsection_name=' +
                    this.props.location.query.subsection_name +
                    '&is_lti_enabled=' +
                    this.props.location.query.is_lti_enabled +
                    '&semester_id=' +
                    this.state.semester_id +
                    '&semester_name=' +
                    this.state.semester_name +
                    '&is_current_semester=' +
                    this.state.is_current_semester
                    :
                    'QuizCreation?course_id=' +
                    this.state.course_id +
                    '&section_id=' +
                    this.state.section_id +
                    '&quiz_id=' +
                    quizList.quiz_id +
                    '&course_name=' +
                    this.props.location.query.course_name +
                    '&section_name=' +
                    this.props.location.query.section_name +
                    '&is_lti_enabled=' +
                    this.props.location.query.is_lti_enabled +
                    '&semester_id=' +
                    this.state.semester_id +
                    '&semester_name=' +
                    this.state.semester_name +
                    '&is_current_semester=' +
                    this.state.is_current_semester

                  }
                  onEditClick={() => this.editSubject(quizList.quiz_id)}
                  handleUpdateAssignmentStatus={(e) => {
                    e.preventDefault();
                    this.handleUpdateAssignmentStatus(quizList, i)
                  }}
                  pushId={'quizList'}
                  onDeleteClick={() => this.delete(i)}
                  instructorSubject = {true}
                  timezone={this.state.timezone}
                  disableActionButtons={this.state.is_current_semester === false}
                />
              ))}
            </tbody>
          </table>
          </Cell>
                :
                undefined
            }

            {
                this.state.showStudents?
                <Cell size={12} className="gradebook-cell">   
                <SectionStudentEnrollmentList {...this.props} hideSubsection={true}  />
                </Cell>
                :
                undefined
            }
        </Grid>
      </SecureShow>
    );
  }
}
